import CurrentUserProfile from '../components/CurrentUserProfile';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';

export default function UserProfile() {
	return (
		<div className="flex flex-col h-screen dashboard-page">
			<Header />
			<div className="flex flex-1 overflow-hidden">
				<Sidebar />
				<CurrentUserProfile />
			</div>
		</div>
	);
}
